import { render, staticRenderFns } from "./account-user-role.vue?vue&type=template&id=5f12a211"
import script from "./account-user-role.vue?vue&type=script&lang=js"
export * from "./account-user-role.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports